import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import { getApiError } from '../../utils';
import { getDeals } from '../../services/portal';

export const fetchDeals = createAsyncThunk<DealResults, string>(
  'deals/fetchDeals',
  async (id: string, { getState, rejectWithValue }) => {
    try {
      const { deals } = getState() as { deals: DealsState };
      return await getDeals(id, {
        page: deals.page,
        size: deals.pageSize,
        keyword: deals.searchQuery,
        status: deals.activeFilters?.['deal-status-group']?.join(','),
        type: deals.activeFilters?.['deal-type']?.[0],
        sort: deals.sortBy,
        order: deals.sortOrder || 'desc',
      });
    } catch (error: unknown) {
      Sentry.captureException(error);

      return rejectWithValue(getApiError(error));
    }
  },
);
